import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Gallery from '../components/Gallery';
import Attractions from '../components/Attractions';
import Location from '../components/Location';
import PropertyManager from '../components/PropertyManager';
import BookingCTA from '../components/BookingCTA';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/toaster';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#faf7f2]">
      <Navbar />
      <Hero />
      <About />
      <Gallery />
      <Attractions />
      <Location />
      <PropertyManager />
      <BookingCTA />
      <Footer />
      <Toaster />
    </div>
  );
};

export default Home;
